import React, { useEffect } from 'react';

import Wrapper from '../Common/FilterWrapper/index';

import { Grid } from '../../components/Grid.components';
import { Loader } from '../../components/Loader.components';
import { Boxed } from '../../components/Boxed.components';
import { Avatar } from '../../components/Avatar.components';
import { Input } from '../../components/Input.components';
import { Icon } from '../../components/style';

import { formatCount, formatDateTime } from '../../utils/utils';
import { TableComponent, PaginationComponent } from '../../components/Table.components';
import { RenderAvatarList, RenderStatus } from './style';

import { Theme } from '../../utils/theme';
import { EmptyState } from '../../components/EmptyState.components';

export const Applications = (props) => {
  // state props
  const {
    fetchActionURL,
    contentList,
    contentTotal,
    isLoading,
    hideSearch,
    hidePagination,
    defaultLimit
  } = props;

  // dispatch props
  const { redirect, fetchAction } = props;

  useEffect(() => {
    let data = {
      page: 1,
      limit: defaultLimit ?? 10
    };
    fetchAction(data);
  }, []);

  const columns = [
    {
      title: 'Request',
      dataIndex: 'profilePictureUrl',
      key: 'profilePictureUrl',
      render: (text, record) => (
        <Avatar
          src={record?.createdBy?.profilePictureUrl}
          size={'38px'}
          status={<RenderStatus status={record?.status} />}
          name={`${record?.requestTitle?.title}`}
          info={`By ${record?.createdBy?.lastName} ${record?.createdBy?.firstName} - ${
            record?.createdAt && formatDateTime(record?.createdAt)
          } `}
          cursor="pointer"
          onClick={() => redirect(`/requests/review/${record?._id}`)}
        />
      )
    },
    {
      title: 'Comment',
      dataIndex: 'comments',
      key: 'comments',
      align: 'center',
      render: (comments, record) => (
        <>
          {comments?.length ? formatCount(comments?.length) : 0}{' '}
          <Icon className="icon-comment-alt" color={Theme.SecondaryTextColor} />
        </>
      )
    },
    {
      title: 'Reviewers',
      dataIndex: 'reviewers',
      key: 'reviewers',
      render: (reviewers, record) => {
        const list = [];

        reviewers?.forEach((item) => {
          if (item?.step === record?.currentStage) {
            item?.reviewers?.forEach((user) => user?._id && list.push(user));
          }
        });

        record?.additionalReviewers?.forEach((item) => {
          list.push(item);
        });

        return (
          <Boxed>
            <RenderAvatarList list={list} />
          </Boxed>
        );
      }
    },
    {
      title: 'Step',
      dataIndex: 'currentStage',
      key: 'currentStage',
      align: 'center',
      render: (text, record) => (
        <>
          <span style={{ fontSize: '20px', color: Theme.PrimaryTextColor }}>{text}</span>/
          {record?.stages}
        </>
      )
    }
  ];

  return (
    <>
      <Wrapper
        externalActionURL={fetchActionURL}
        render={({
          changePageSize,
          handlePagination,
          currentPage,
          pageSize,
          search,
          pageOptions
        }) => {
          return (
            <>
              {!hideSearch && (
                <Grid desktop="repeat(4, 1fr)" tablet="repeat(4, 1fr)" mobile="repeat(1, 1fr)">
                  <Boxed pad="5px 0">
                    <Input
                      type="search"
                      placeholder="Search..."
                      onChange={(value) => search(value, fetchActionURL)}
                    />
                  </Boxed>
                </Grid>
              )}
              {contentTotal > 0 ? (
                <>
                  {isLoading ? (
                    <Boxed display="flex" pad="20px">
                      <Loader margin="auto" />
                    </Boxed>
                  ) : (
                    <>
                      <Boxed pad="10px 0">
                        <TableComponent columns={columns} data={contentList} />
                        {!hidePagination && (
                          <Boxed pad="10px 0 ">
                            <PaginationComponent
                              total={contentTotal}
                              onChange={(page) => handlePagination(page, fetchActionURL)}
                              current={currentPage}
                              pageCounts={pageOptions}
                              changePageSize={(pageSize) =>
                                changePageSize(pageSize, fetchActionURL)
                              }
                              pageSize={pageSize}
                              itemsDisplayed
                              showTotal={(total, range) => {
                                return `${range[0]} - ${range[1]} of ${contentTotal} items`;
                              }}
                            />
                          </Boxed>
                        )}
                      </Boxed>
                    </>
                  )}
                </>
              ) : (
                <EmptyState />
              )}
            </>
          );
        }}
      />
    </>
  );
};
